import React from 'react'
import { useTranslation } from 'react-i18next'

const CountrySelectionModal = ({
  isOpen,
  onSelectCountry,
  countries,
  countryConfigs,
}) => {
  const { t } = useTranslation('country')
  if (!isOpen) return null

  const handleCountrySelect = (countryCode) => {
    onSelectCountry(countryCode)
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm">
      <div className="relative w-full max-w-md mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden animate-fade-in">
        {/* Header */}
        <div className="bg-[#DCA950] px-6 py-8 text-center">
          <h2 className="text-2xl font-bold text-black mb-2">
            {t('welcome')}
          </h2>
          <p className="text-gray-800 text-sm">
            {t('selectCountryPrompt')}
          </p>
        </div>

        {/* Countries List */}
        <div className="p-6 space-y-3">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">
            {t('selectCountry')}
          </h3>

          {countries.map((countryCode) => {
            const config = countryConfigs[countryCode]
            return (
              <button
                key={countryCode}
                onClick={() => handleCountrySelect(countryCode)}
                className="w-full p-4 rounded-xl border-2 border-gray-200 hover:border-[#DCA950] hover:bg-[#DCA950]/50 transition-all duration-300 group flex items-center justify-between transform hover:scale-[1.02] active:scale-[0.98]"
              >
                <div className="flex items-center space-x-4">
                  <span className="text-3xl">{config.flag}</span>
                  <div className="text-left">
                    <div className="font-semibold text-gray-500 group-hover:text-black">
                      {t(countryCode)}
                    </div>
                    <div className="text-sm text-gray-500">
                      {t('currency', { currency: config.currency })}
                    </div>
                  </div>
                </div>
                <div className="text-[#DCA950] opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <svg
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </button>
            )
          })}
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <p className="text-xs text-gray-800 text-center">
            {t('changeAnytime')}
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
      `}</style>
    </div>
  )
}

export default CountrySelectionModal
